import React from 'react';

// Image component with URL, mode, and aspect ratio control functionality
const ImageComponent = ({ 
  url = 'https://images.unsplash.com/photo-1449824913935-59a10b8d2000?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
  mode = 'inline',
  aspectRatio = '4:3'
}) => {
  // Get aspect ratio value
  const getAspectRatioValue = () => {
    const ratios = {
      '1:1': '1/1',
      '4:3': '4/3',
      '3:2': '3/2',
      '16:9': '16/9',
      '21:9': '21/9',
      '2:3': '2/3',
      '3:4': '3/4',
      '9:16': '9/16',
      'auto': 'auto'
    };
    return ratios[aspectRatio] || '4/3';
  };

  // Get the container and image styles based on aspect ratio
  const getContainerStyle = () => {
    if (aspectRatio === 'auto') {
      return { height: 'auto' };
    }
    return { 
      aspectRatio: getAspectRatioValue(),
      width: '100%'
    };
  };

  const getImageStyle = () => {
    return {
      width: '100%',
      height: '100%',
      objectFit: 'cover'
    };
  };

  // Inline mode - image as a contained element
  if (mode === 'inline') {
    return (
      <div 
        className="w-full overflow-hidden rounded-lg shadow-xl"
        style={getContainerStyle()}
      >
        <img
          src={url}
          alt=""
          style={getImageStyle()}
          onError={(e) => {
            e.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODAwIiBoZWlnaHQ9IjYwMCIgdmlld0JveD0iMCAwIDgwMCA2MDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSI4MDAiIGhlaWdodD0iNjAwIiBmaWxsPSIjRjNGNEY2Ii8+CjxwYXRoIGQ9Ik0zNTAgMjUwSDQ1MFYzNTBIMzUwVjI1MFoiIGZpbGw9IiM5Q0EzQUYiLz4KPHBhdGggZD0iTTMwMCA0MDBINTAwVjQ1MEgzMDBWNDAwWiIgZmlsbD0iIzlDQTNBRiIvPgo8L3N2Zz4K';
          }}
        />
      </div>
    );
  }

  // Background mode - image as background with gradient overlay
  if (mode === 'bg') {
    return (
      <div 
        className="w-full rounded-lg shadow-xl relative overflow-hidden"
        style={{
          backgroundImage: `url(${url})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          ...getContainerStyle()
        }}
      >
        {/* Gradient overlay for better text readability */}
        <div className="absolute inset-0 bg-linear-to-r from-white via-white/95 to-transparent dark:from-slate-900 dark:via-slate-900/95 dark:to-transparent"></div>
      </div>
    );
  }

  // Default fallback
  return (
    <div 
      className="w-full bg-gray-200 dark:bg-gray-700 rounded-lg shadow-xl flex items-center justify-center"
      style={getContainerStyle()}
    >
      <span className="text-gray-500 dark:text-gray-400">No image selected</span>
    </div>
  );
};

export const Image = {
  resolveFields: (data) => {
    const fields = {
      url: {
        type: 'text',
        label: 'URL',
        placeholder: 'https://images.unsplash.com/...'
      },
      mode: {
        type: 'select',
        label: 'Modus',
        options: [
          { label: 'Inline', value: 'inline' },
          { label: 'Hintergrund', value: 'bg' }
        ]
      },
      aspectRatio: {
        type: 'select',
        label: 'Seitenverhältnis',
        options: [
          { label: '4:3 Standard (800x600)', value: '4:3' },
          { label: '16:9 Breitbild', value: '16:9' },
          { label: '1:1 Quadrat', value: '1:1' },
          { label: '3:2 Klassisch', value: '3:2' },
          { label: 'Automatisch', value: 'auto' }
        ]
      }
    };

    return fields;
  },
  defaultProps: {
    url: 'https://images.unsplash.com/photo-1449824913935-59a10b8d2000?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
    mode: 'inline',
    aspectRatio: '4:3'
  },
  render: ImageComponent
};
